// Lazysizes
import 'lazysizes';
import priorityNav from 'priority-nav';
import { tns } from "../../node_modules/tiny-slider/src/tiny-slider"

// Alpine bootup

import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect'
import persist from '@alpinejs/persist'
import focus from '@alpinejs/focus'
import collapse from '@alpinejs/collapse'
import AutoAnimate from '@marcreichel/alpine-auto-animate';

Alpine.plugin(AutoAnimate);
Alpine.plugin(intersect);
Alpine.plugin(persist);
Alpine.plugin(focus);
Alpine.plugin(collapse);
window.Alpine = Alpine;


document.addEventListener('alpine:init', () => {
    // Tiny slider init
    window.tns = tns;

    Alpine.store('bodyLock', {
        on: false,

        toggle() {
            this.on = !this.on
        }
    })
    
    Alpine.store('modal', '')
})

Alpine.start();


var dropdownLabel = document.querySelector("[data-priority-label]").dataset.priorityLabel;

priorityNav.init({
    mainNavWrapper: '[data-priority-nav="wrapper"]',
    mainNav: '[data-priority-nav="nav"]',
    navDropdownToggleClassName: 'nav__more',
    navDropdownLabel: dropdownLabel,
    offsetPixels: 10, // increase to decrease the time it takes to move an item.
    throttleDelay: 50, // this will throttle the calculating logic on resize because i'm a responsible dev.
})

let navToggle = document.querySelector('.nav-toggle')
let bars = document.querySelectorAll('.bar')

//function toggleHamburger(e) {
//    bars.forEach(bar => bar.classList.toggle('x'))
//}

//navToggle.addEventListener('click', toggleHamburger)